export default __webpack_public_path__ + "static/media/carousel-3.d208f1fb.png";